import './index.css';

import * as React from 'react';
import { connect } from 'react-redux';

interface IProps {
  memoId: number;
  groupTitle: string;
}

class ReferenceComponent extends React.Component<IProps> {
  componentDidMount() {
    location.href =
      '/' +
      this.props.groupTitle +
      '/memos#reference?memo=' +
      this.props.memoId;
  }
  render() {
    return null;
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  memoId: Number(ownProps.match.params.memoId),
  groupTitle: ownProps.match.params.group
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    // something
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReferenceComponent);



// WEBPACK FOOTER //
// ./src/components/Memo/reference.tsx